import { Badge } from '@/components/shadcn/ui/badge';
import TooltipV2 from '@/components/Tooltip/TooltipV2';
import { cn } from '@/lib/cn';

import { getPreviousPeriodDescription } from '../../lib/signal-date-preset.utils';
import {
  getChangePercentage,
  isNewSignalIssue,
} from '../../lib/signal-issue.utils';
import type { SignalDateSelectionInput } from '../../model';

export const ChangesLabel = (props: {
  comparisonPeriodCount: number;
  selectedPeriodCount: number;
  className?: string;
  datePreset?: SignalDateSelectionInput;
}) => {
  const { comparisonPeriodCount, selectedPeriodCount, className, datePreset } =
    props;
  const changeValue = getChangePercentage(
    comparisonPeriodCount,
    selectedPeriodCount,
  );
  const baseClassName = cn(
    'text-sm leading-[22px] text-right font-medium',
    className,
  );
  if (isNewSignalIssue({ comparisonPeriodCount, selectedPeriodCount })) {
    const periodDescription = datePreset
      ? getPreviousPeriodDescription(datePreset)
      : 'period';

    return (
      <TooltipV2
        tooltipNode={`This issue did not appear in the previous ${periodDescription}.`}
      >
        <Badge variant="secondary">New</Badge>
      </TooltipV2>
    );
  }
  if (changeValue === null) return null;
  return (
    <label
      className={cn(
        baseClassName,
        changeValue === 0 && 'text-gray-700',
        changeValue > 0 && 'text-destructive',
        changeValue < 0 && 'text-green-600',
      )}
    >
      {changeValue > 0 && '+'}
      {changeValue.toFixed(1)}%
    </label>
  );
};
